import {isNotEmail} from "../../app/support/functions";

$(function () {

    $('#loginForm').on('submit', function (event) {

        let errors    = [];

        let $email    = $('#email');
        let $password = $('#password');

        let email     = $email.val().trim();
        let password  = $password.val().trim();

        if (!email) {
            errors.push({
                element: $email,
                message: Lang.validation('required', 'email')
            });
        }
        else if (isNotEmail(email)) {
            errors.push({
                element: $email,
                message: Lang.validation('email', 'email')
            });
        }
        else {
            $email
                .removeClass('is-invalid')
                .next('.label-danger')
                .html(' ')
                .addClass('hidden');
        }

        if (!password) {
            errors.push({
                element: $password,
                message: Lang.validation('required', 'password')
            });
        }
        else {
            $password
                .removeClass('is-invalid')
                .next('.label-danger')
                .html(' ')
                .addClass('hidden');
        }

        if (! errors.length) {
            return true
        }

        errors.forEach(function(error) {
            let $element      = error.element;
            let $elementAlert = $element.next('.label-danger');
            let message       = error.message;

            $elementAlert.html(message).removeClass('hidden');
            $element.addClass('is-invalid');
        });

        $('#loginForm').animate({
            scrollTop: 0
        }, 500);

        return false;
    });
});
